<template>
  <user-work-relationship-page-content
    :relationship="USER_WORK_RELATIONSHIPS.SAVED_FOR_LATER"
    ref="content"
  ></user-work-relationship-page-content>
</template>

<script>
import userWorkRelationshipPageContent from "../components/user-work-relationship-page-content.vue";
import { USER_WORK_RELATIONSHIPS } from "../util/constants";

export default {
  name: "saved-for-later",
  components: { userWorkRelationshipPageContent },

  data: () => ({
    USER_WORK_RELATIONSHIPS,
  }),

  beforeRouteLeave(to, from, next) {
    this.$refs.content.prepareRouteLeave();

    next();
  },
};
</script>
